import { Text, View } from "@react-pdf/renderer";
import { type FunctionComponent } from "react";

import { styles } from "./PriceInfo.styles";

interface PriceInfoProps {
    priceInfo: string;
    quantityInfo: string;
}

const PriceInfo: FunctionComponent<PriceInfoProps> = ({ quantityInfo, priceInfo }) => {
    return (
        <View style={styles.root}>
            <View style={styles.row}>
                <Text style={styles.textStar}>*</Text>

                <Text>{priceInfo}</Text>
            </View>

            <View style={styles.row}>
                <Text style={styles.textStar}>**</Text>

                <Text>{quantityInfo}</Text>
            </View>
        </View>
    );
};

export { PriceInfo };
